<template>
  <div>
    <div slot="header" class="box-card-header">
      <span>新闻列表</span>
    </div>
    <div class="news-list">
      <div class="list-item" v-for="(item,index) in newsList" :key="index" v-on:click="toNewsDetail(item.id)">
        {{ item.title}}
        <span class="date">{{item.publishDate}}</span>
      </div>
      <div class="list-pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-count="totalPages"
          :current-page="pageNo-1"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import {news} from 'src/api/stadiumApi'
  import {mapState, mapActions} from 'vuex'
  import {isNotEmpty} from 'src/utils/myUtils'

  export default {
    data () {
      return {
        pageSize: 10,
        pageNo: 1,
        totalPages: 1,
        newsList: []
      }
    },
    components: {},
    mounted () {
      this.$nextTick(function () {
        this.refreshSortId()
      })
    },
    watch: {
      '$route': 'refreshSortId',
      '$store.state.currentSortId': function () {
        this.pageNo = 1
        if (isNotEmpty(this.currentSortId)) {
          this.refreshNews()
        }
      }
    },
    computed: mapState({
      currentSortId: state => state.currentSortId
    }),
    methods: {
      ...mapActions([
        'updateCurrentNewsSortId'
      ]),
      refreshSortId () {
        this.updateCurrentNewsSortId(this.$route.query.sortId)
      },
      refreshNews () {
        news(this.currentSortId, this.pageNo, this.pageSize).then((resp) => {
          this.newsList = []
          this.newsList = this.newsList.concat(resp.content)
          this.totalPages = resp.totalPages
          if (this.pageNo < resp.totalPages) {
            this.pageNo++
          }
        })
      },
      toNewsDetail (id) {
        this.$router.push({
          name: 'NewsDetail',
          query: {
            id: id
          }
        })
      },
      handleCurrentChange (currentPage) {
        this.pageNo = currentPage
        this.refreshNews()
      }
    }
  }
</script>
<style>
</style>




// WEBPACK FOOTER //
// src/pages/news/List.vue